import React from 'react';

import l10n from "../../../l10n/localization";

import { Table } from "react-materialize";
import Loader from "../../common/Loader";
import * as clientRateActions from "../../../actions/clientRate";
import {connect} from "react-redux";
import ClientRateItem from "./RateItem";

class ClientRateTable extends React.Component {

    componentDidMount() {
        this.props.dispatch(clientRateActions.fetchRates(this.props.client.id, true));
    }

    render() {
        if (this.props.loading || this.props.clientRates === undefined) {
            return (<div><Loader /></div>)
        }
        return (

        <Table bordered>
                <thead>
                <tr>
                    <th data-field="name">{l10n.client.rate.name}</th>
                    <th data-field="creation_date">{l10n.client.rate.creationDate}</th>
                    <th data-field="is_marine_only">{l10n.client.rate.isMarineOnly}</th>
                    <th data-field="rate">{l10n.client.rate.rate}</th>
                    <th data-field="franchise">{l10n.client.rate.franchise}</th>
                    <th data-field="actions">{l10n.client.actions}</th>
                </tr>
                </thead>

                <tbody>
                {this.props.clientRates.map((item, index) => (
                    <ClientRateItem {...this.props} item={item} client={this.props.client} openDrawer={this.props.openDrawer} key={index} depth={this.props.depth + 1}/>
                ))}
                </tbody>
            </Table>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        clientRates: state.clientRate.clientRates,
        loading: state.clientRate.loading,
        deletingClientrate: state.clientRate.deleting
    });
})(ClientRateTable);



// WEBPACK FOOTER //
// ./src/components/client/clientRate/ClientRateTable.js